<template>
  <div class="my">
    <div class="avatar">
      <div class="contianer">
        <el-button class="go_back" @click="goBack">
          <img src="../assets/previous.svg" alt="返回上一级" />
        </el-button>
        <div class="ava_con">
          <div class="ava_img" @click="handleAvatarClick">
            <el-avatar :size="size" :src="userInfo.avatar"></el-avatar>
            <el-upload
              ref="upload"
              class="avatar-uploader"
              action="/adminapi/upload/image"
              :headers="getUploadHeaders()"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-button slot="trigger" style="display: none;"></el-button>
            </el-upload>
          </div>
          <div class="ava_txt">
            <div class="name">{{ userInfo.name }}</div>
            <div class="num">编号：{{ userInfo.account }}</div>
          </div>
        </div>
        <div class="quit" @click="logout">
          <img src="../assets/quit.svg" alt="">
          退出
        </div>
      </div>
    </div>
    <div class="my_wrap">
      <div class="contianer">
        <div class="asstes">
          <div class="ass_top">
            <div class="tit">我的测评</div>
            <router-link class="more" to="/student">查看更多 <i><img src="../assets/unfold.svg" alt="更多" /></i></router-link>
          </div>
          <div class="ass_wrap">
            <router-link class="item" to="/student?status=5">
              <el-badge :value="statusCount.status_5">
                <div class="icon">
                  <img src="../assets/asstes_icon01.svg" alt="等待测评" />
                </div>
                <div class="para">等待测评</div>
              </el-badge>
            </router-link>
            <router-link class="item" to="/student?status=8">
              <el-badge :value="statusCount.status_8">
                <div class="icon">
                  <img src="../assets/asstes_icon02.svg" alt="等待报告" />
                </div>
                <div class="para">等待报告</div>
              </el-badge>
            </router-link>
            <router-link class="item" to="/student?status=11">
              <el-badge :value="statusCount.status_11">
                <div class="icon">
                  <img src="../assets/asstes_icon03.svg" alt="测评完成" />
                </div>
                <div class="para">测评完成</div>
              </el-badge>
            </router-link>
          </div>
        </div>
        <div class="list">
          <router-link class="item" to="/mystudents">
            <div class="txt">
              <div class="hxfont">&#xe798;</div>
              <div class="bt">我的学员</div>
            </div>
            <div class="unfold"><img src="../assets/unfold.svg" alt="" /></div>
          </router-link>
          <router-link class="item" to="/addstudy">
            <div class="txt">
              <div class="hxfont">&#xe797;</div>
              <div class="bt">新增学员</div>
            </div>
            <div class="unfold"><img src="../assets/unfold.svg" alt="" /></div>
          </router-link>
          <router-link class="item" to="/student?status=88">
            <div class="txt">
              <div class="hxfont">&#xe796;</div>
              <div class="bt">测评历史</div>
            </div>
            <div class="unfold"><img src="../assets/unfold.svg" alt="" /></div>
          </router-link>
          <router-link class="item" to="/student?status=2&tabName=学员报告">
            <div class="txt">
              <div class="hxfont">&#xe791;</div>
              <div class="bt">学员报告</div>
            </div>
            <div class="unfold"><img src="../assets/unfold.svg" alt="" /></div>
          </router-link>
          <router-link class="item" to="/track">
            <div class="txt">
              <div class="hxfont">&#xe649;</div>
              <div class="bt">跟踪列表</div>
            </div>
            <div class="unfold"><img src="../assets/unfold.svg" alt="" /></div>
          </router-link>
          <router-link class="item" to="/myself">
            <div class="txt">
              <div class="hxfont">&#xe607;</div>
              <div class="bt">我的资料</div>
            </div>
            <div class="unfold"><img src="../assets/unfold.svg" alt="" /></div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setUserInfo } from '@/api/user'
import useUserStore from '../stores/modules/user'
import useAppStore from '../stores/modules/app'
export default {
  name: 'Home',
  created () {
    this.userStore = useUserStore()
    this.appStore = useAppStore()
  },
  data () {
    return {
      name: '黄老师',
      number: '001',
      circleUrl: require('@/assets/avatar_img.jpg'),
      size: 'large',
      userStore: null,
      userInfo: {},
      statusCount: {}
    }
  },
  mounted () {
      this.getUser()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    getUploadHeaders () {
      return {
        Token: this.userStore.token
      }
    },
    // 获取个人设置
    async getUser () {
      console.log('====getuser=1==')
      await this.userStore.getUserInfo()

      this.userInfo = this.userStore.userInfo // , this.userStore.routes, this.userStore.perms   userInfo
      // 状态:0-等待测评,1-等待报告(也是测试中的),2-查看报告（测试完成的）
      this.statusCount = this.userStore.statusCount
      console.log(this.userInfo)
        // for (const key in formData) {
        //     // formData[key] = userInfo[key]
        // }
    },
    async logout () {
      await this.userStore.logout()
      this.$router.push('/?dp='+ this.appStore.getDpId())
    },
    handleAvatarClick () {
      this.$refs.upload.$el.querySelector('input').click()
    },
    async handleAvatarSuccess (response, file) {
      // console.log(response)
      this.circleUrl = response.data.uri // URL.createObjectURL(file.raw)
      await setUserInfo({ avatar: response.data.uri })
      this.getUser()
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    }
  }
}
</script>
<style>
.my{
  min-height: 100vh;
  background: #efefef;
}
.my .avatar {
  width: 100%;
  background: linear-gradient(90deg, #ff9b00, #accd05);
  padding: 1rem 0 5rem;
  display: block !important;
}
.avatar .contianer {
  position: relative;
}
.avatar .ava_con {
  display: flex;
  align-items: center;
  margin-top: .5rem;
}
.avatar .ava_con .el-avatar {
  width: 3.88rem;
  height: 3.88rem;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: .63rem;
}
.avatar .ava_con .el-avatar img{
  min-width:  100%;
  min-height: 100%;
  height: auto;
}
.avatar .ava_con .avatar-uploader{
  display: none;
}
.avatar .ava_con .ava_txt {
  color: #fff;
}
.avatar .ava_con .ava_txt .name {
  font-size: 1.13rem;
  line-height: 100%;
}
.avatar .ava_con .ava_txt .num {
  font-size: .88rem;
  line-height: 100%;
  margin-top: .75rem;
}
.avatar .quit {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  font-size: .88rem;
  cursor: pointer;
}
.avatar .quit img {
  width: .88rem;
  margin-right: 3px;
}
.my_wrap {
  height: 100%;
  padding-bottom: calc(2rem + 68px);
}
.my_wrap .asstes {
  width: 100%;
  padding: 1.13rem;
  border-radius: 1.13rem;
  background: #fff;
  transform: translateY(-50px);
}
.my_wrap .asstes .ass_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.my_wrap .asstes .ass_top .tit {
  font-size: 1.13rem;
  font-weight: bold;
  color: #000;
}
.my_wrap .asstes .ass_top .more {
  font-size: .88rem;
  font-weight: bold;
  color: #000;
}
.my_wrap .asstes .ass_wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 1.88rem;
}
.my_wrap .asstes .ass_wrap .item {
  width: calc(100% / 3);
  text-align: center;
}
.my_wrap .asstes .ass_wrap .item .el-badge__content {
  right: 17px;
  background-color: #fa5151;
}
.my_wrap .asstes .ass_wrap .item .icon {
  width: 3.13rem;
  height: 3.13rem;
  margin: 0 auto;
  background: linear-gradient(0deg,#FF7200 4%,#FF9C00);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.my_wrap .asstes .ass_wrap .item .icon img {
  width: 28px;
}
.my_wrap .asstes .ass_wrap .item .para {
  margin-top: .63rem;
  font-size: .88rem;
  line-height: 100%;
}
.my_wrap .list {
  width: 100%;
  padding: 2rem 1.13rem;
  border-radius: 1.13rem;
  background: #fff;
  margin-top: -1.56rem;
}
.my_wrap .list .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.56rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.my_wrap .list .item + .item {
  padding-top: 1.56rem;
}
.my_wrap .list .item .txt {
  display: flex;
  align-items: center;
}
.my_wrap .list .item .txt .hxfont {
  width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.65rem;
  font-size: 1.35rem;
  color: #ff9c00;
  line-height: 100%;
}
.my_wrap .list .item .txt .bt {
  font-size: 1.13rem;
  line-height: 100%;
  font-weight: bold;
}
.my_wrap .list .item .unfold {
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.my_wrap .list .item .unfold img {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue